export default class FoodTruckService {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  async create(foodTruck, options) {
    const response = await fetch(`${this.baseUrl}/foodTruck`, {
      body: JSON.stringify(foodTruck),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async sendCredentials(id, options) {
    const response = await fetch(`${this.baseUrl}/foodTruck/${id}/sendCredentials`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.ok
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUrl}/foodTruck/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUrl}/foodTruck/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUrl}/foodTruck`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, foodTruck, options) {
    const response = await fetch(`${this.baseUrl}/foodTruck/${id}`, {
      body: JSON.stringify(foodTruck),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}